<template>
  <div id="app">
    <transition name="fade">
        <router-view></router-view>
    </transition>
  </div>
</template>

<script>

import {defaultFontSize,adoptdevice} from '@/util/util'

export default {
	data(){
		return {
			defaultFontSize:"",
		}
	},
	created(){
		this.defaultFontSize=defaultFontSize()
		adoptdevice(750,100,this.defaultFontSize);
		window.addEventListener("resize",()=>{
			setTimeout(()=>{
				adoptdevice(750,100,this.defaultFontSize);
			},200)
		})
	},
	mounted(){

	},

};

</script>

<style scoped lang="scss" style="stylesheet/sass">
</style>




// WEBPACK FOOTER //
// src/App.vue